import {axios} from '@/api/axios';
import {CAMERA_URLS} from '@/api/urls';
import {formatString} from '@/utils';
import {Camera, SavedCameraType} from '@/types/camera-type';

export const CameraApi = {
  getList: () => axios.get<Camera[]>(CAMERA_URLS.GET_LIST),
  getListByParam: (params: string) => axios.get<SavedCameraType[]>(`${CAMERA_URLS.GET_LIST}?${params}`),
  getListByEvent: (id: string) => axios.get<Camera[]>(formatString(CAMERA_URLS.GET_LIST_BY_EVENT, id)),
  getOne: (cameraId: string) => axios.get<Camera>(formatString(CAMERA_URLS.GET_EVENT, cameraId)),

  save: (data: Camera) => axios.post<Camera>(CAMERA_URLS.SAVE, data),
  bulkSave: (data: Camera[]) => axios.post<Camera>(CAMERA_URLS.BULK_SAVE, {bulk: data}),
  edit: (cameraId: string, data: Camera) => axios.put<Camera>(formatString(CAMERA_URLS.EDIT, cameraId), data),
  delete: (cameraId: string) => axios.delete<Camera>(formatString(CAMERA_URLS.EDIT, cameraId))
};
